<script setup lang="ts">
  import ModalModelPartsVideo from '../../components/Modais/ModalModelPartsVideo.vue'
  import ModalMessages from '../../components/Modais/ModalMessages.vue'
  import { localeStore } from '../../stores/locale'
  import { userStore } from '../../stores/user'
  import { computed, onMounted, ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import VuePlyr from 'vue-plyr'
  import 'vue-plyr/dist/vue-plyr.css'
  import api from '../../api'

  const storeLocale = localeStore()
  const storeUser = userStore()
  const route = useRoute()
  const props = defineProps(['model', 'translate'])
  const emit = defineEmits(['plans'])

  const reactiveLocale = computed(() => storeLocale.locale)
  const reativeIsLoggedIn = computed(() => storeUser.isLoggedIn)
  interface VideoPath {
    id: string
    livePath: string
    name: string
  }
  const name = ref('')
  const description = ref('')
  const text = ref('')
  const sessionIndex = ref(0)
  const shoots = ref([])
  const videoSelect = ref<VideoPath | false>(false)
  const selectResolution = ref('360p')
  const showPartsVideo = ref(false)
  const videos = ref([])
  const partId = ref(0)
  const thumbVideo = ref('')
  const preview = ref(null)
  const videoSource = ref({
    type: 'video',
    sources: [
      {
        src: 'https://www.example.com/video1.mp4',
        type: 'video/mp4'
      }
    ]
  })
  const options = ref({
    showModal: false,
    titleModal: '',
    textBodyModal: '',
    textButtonModal: '',
    routerName: '',
    functionOptions: null,
    showClose: true
  })

  const plyrOptions = ref({
    controls: [
      'play-large', // The large play button in the center
      'restart', // Restart playback
      'rewind', // Rewind by the seek time (default 10 seconds)
      'play', // Play/pause playback
      'fast-forward', // Fast forward by the seek time (default 10 seconds)
      'progress', // The progress bar and scrubber for playback and buffering
      'current-time', // The current time of playback
      'duration', // The full duration of the media
      'mute', // Toggle mute
      'volume', // Volume control
      'captions', // Toggle captions
      'settings'
    ],
    fullscreen: {
      enabled: true,
      iosNative: true
    },
    settings: ['quality', 'speed'],
    debug: false,
    quality: {
      options: [],
      forced: true,
      default: 360
    }
  })

  onMounted(() => {
    if (props.model) {
      getModel()
    }
  })

  watch(
    () => props.model,
    () => {
      getModel()
    }
  )

  watch(sessionIndex, (value) => {
    videos.value = props.model.shoot[value].lives
    partId.value = props.model.shoot[value].id
    thumbVideo.value = props.model.firstPhotoSection[value][0]
    videoSelect.value = props.model.shoot[value].lives.length
      ? props.model.shoot[value].lives[0]
      : false
    videoSource.value.sources[0].src = videoSelect.value ? videoSelect.value.livePath : ''
    preview.value.player.source = videoSource.value
  })

  watch(preview, (value) => {
    value.player.source = videoSource.value
    value.player.poster = thumbVideo.value

    value.player.on('ended', () => {
      handleEnded()
    })
    value.player.on('pause', () => {
      handlePause()
    })
  })

  function getModel() {
    name.value = props.model.nameModel
    description.value = props.model.descriptionModel
    text.value = props.model.text
    shoots.value = props.model.shoot
    partId.value = props.model.shoot[0].id
    videos.value = props.model.shoot[0].lives
    thumbVideo.value = props.model.firstPhotoSection[0][0]
    videoSelect.value = props.model.shoot[0].lives.length ? props.model.shoot[0].lives[0] : false
    videoSource.value.sources[0].src = videoSelect.value ? videoSelect.value.livePath : ''
  }
  function showModalMessages(data) {
    options.value.showModal = data.message.show
    options.value.titleModal = data.message.title
    options.value.textBodyModal = data.message.textBoby
    options.value.textButtonModal = data.message.textButton
    options.value.routerName = data.message.routerName
    options.value.functionOptions = data.message.functionOptions
    options.value.showClose = data.message.showClose
  }
  function showModalModelPartsVideo(value) {
    showPartsVideo.value = value
  }
  function changeResolutionMobile(resolution: number) {
    videoSelect.value = videos.value[resolution]
    selectResolution.value = videos.value[resolution].name
  }
  function modalConfirmDownload(id) {
    showModalMessages({
      message: {
        show: true,
        title:
          reactiveLocale.value == 'en'
            ? 'Click CONFIRM DOWNLOAD to confirm that you want to download the video'
            : 'Clique em CONFIRMAR DOWNLOAD para confirmar que você deseja baixar o vídeo',
        textButton: reactiveLocale.value == 'en' ? 'CONFIRM DOWNLOAD' : 'CONFIRMAR DOWNLOAD',
        textBoby:
          reactiveLocale.value == 'en'
            ? 'This video will use 1 credit from your account'
            : 'Este vídeo utilizará 1 crédito da sua conta',
        functionOptions: { name: 'solicitaDownload', parameter: id },
        showClose: true
      }
    })
  }
  const handlePause = () => {
    emit('plans', true)
  }

  const handleEnded = () => {
    emit('plans', true)
  }
  async function solicitaDownload(id) {
    api
      .get(
        'v1/videoscredits/solicitaDownload/video/' +
          id +
          `?locale=${reactiveLocale.value ?? route.params.locale ?? 'pt-br'}`
      )
      .then(({ data }) => {
        if (!data.error)
          showModalMessages({
            message: {
              show: true,
              title:
                reactiveLocale.value == 'en'
                  ? 'Your download is being processed!'
                  : 'Seu download está sendo processado!',
              textButton: reactiveLocale.value == 'en' ? 'Close' : 'Fechar',
              textBoby: data.message
            }
          })
        else if (
          data.message.includes('Adquira créditos para realizar o download') ||
          data.message.includes('Purchase credits in order to download')
        ) {
          showModalMessages({
            message: {
              show: true,
              title:
                reactiveLocale.value == 'en'
                  ? 'Error your download!'
                  : 'Falha ao solicitar download!',
              textButton: reactiveLocale.value == 'en' ? 'BUY CREDITS' : 'COMPRAR CRÉDITOS',
              textBoby: data.message,
              routerName: 'AssineOptionsPage'
            }
          })
        } else {
          showModalMessages({
            message: {
              show: true,
              title:
                reactiveLocale.value == 'en'
                  ? 'Error your download!'
                  : 'Falha ao solicitar download!',
              textButton: reactiveLocale.value == 'en' ? 'Close' : 'Fechar',
              textBoby: data.message
            }
          })
        }
      })
      .catch((err) => {
        showModalMessages({
          message: {
            show: true,
            title:
              reactiveLocale.value == 'en'
                ? 'Error your download!'
                : 'Falha ao solicitar download!',
            textButton: reactiveLocale.value == 'en' ? 'Close' : 'Fechar',
            textBoby: err.response.data.message
          }
        })
      })
  }
</script>
<template>
  <div class="block block--white mt-3">
    <div class="d-flex">
      <div class="col-lg-5 model-data">
        <h1 class="title model-info">
          {{ name }}
          <span>Lives</span>
        </h1>
        <h3 class="description mt-3 model-info">
          {{ description }}
        </h3>
        <p class="ml-5 mt-3 text model-info">
          {{ text }}
        </p>
      </div>
      <div class="col-lg-7">
        <div class="col-12">
          <div class="card-pagination pr-3 pb-4 cursor-pointer">
            <div class="img-box">
              <div class="preview" v-if="videoSelect">
                <vue-plyr
                  ref="preview"
                  @pause="handlePause"
                  @ended="handleEnded"
                  :options="plyrOptions"
                  :source="videoSource"
                >
                  <video :autoplay="false" controls playsinline :poster="thumbVideo">
                    <source src="" type="video/mp4" />
                  </video>
                </vue-plyr>
              </div>
              <div v-else class="img-box" @click="$emit('plans', true)">
                <img :src="thumbVideo" :alt="name" />
                <div class="play-icon">
                  <font-awesome-icon :icon="['fas', 'circle-play']" size="2xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row buttons-video bg-white py-2 px-4">
          <div class="col-lg-2 col-4 d-flex justify-content-center align-items-center">
            <select
              class="form-select py-2"
              aria-label="Default-select-parts"
              v-model="sessionIndex"
            >
              <option selected disabled>{{ translate.sessions }}</option>
              <option :value="index" v-for="(shoot, index) in shoots" :key="shoot.name">
                {{ shoot.name }}
              </option>
            </select>
          </div>

          <div
            class="col-lg-2 col-2 d-flex justify-content-center align-items-center mobile-download"
            @click="reativeIsLoggedIn ? modalConfirmDownload(partId) : $emit('plans', true)"
            v-if="partId !== 777 && partId !== 264"
          >
            <button type="button" class="btn btn-outline-secondary btn-lg px-2 btn-desktop">
              <span class="video-options">{{ translate.download }}</span>
              <font-awesome-icon
                :icon="['fas', 'download']"
                size="md"
                style="color: #b20000; margin-left: 3px"
              />
            </button>
            <font-awesome-icon
              :icon="['fas', 'download']"
              size="md"
              style="color: #b20000; margin-left: 3px"
            />
          </div>

          <div class="col-lg-2 col-2 text-center mt-2 mobile-sections">
            <span @click="showModalModelPartsVideo(true)" style="color: #b20000; cursor: pointer">{{
              translate.quality
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalModelPartsVideo
    @showModalModelPartsVideo="showModalModelPartsVideo"
    :showPartsVideo="showPartsVideo"
    :parts="shoots"
    :translate="translate"
    @changeResolution="changeResolutionMobile"
  />
  <ModalMessages
    @showModalMessages="showModalMessages"
    @solicitaDownload="solicitaDownload"
    :options="options"
  />
</template>

<style scoped lang="css">
  .block {
    padding: 28px 0;
  }

  #model-video-box {
    width: 827px;
    height: 465px;
  }

  .model-info {
    padding-left: 137px;
  }

  h3 h1 p {
    font-family: 'Exo-2';
  }

  .name-video {
    font-family: 'Exo-2';
    font-size: 12px;
    font-weight: bold;
    color: #b20000;
  }

  .title {
    color: #000000;
    font-family: 'Bebas-Neue';
    font-size: 72px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 72px;
  }

  .description {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .text {
    height: 76px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    max-width: 370px;
  }

  .video-options {
    height: 19px;
    font-family: 'Exo-2';
    font-size: 15px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .row .buttons-video > .col,
  .row > [class*='col-'] {
    padding-right: 5px;
    padding-left: 5px;
  }

  .btn-outline-dark {
    font-size: 14px;
    font-weight: 500;
    border-radius: 30px;
  }

  .btn-outline-secondary {
    font-size: 14px;
    font-weight: 600;
    border-radius: 30px;
    border: none;
  }

  .form-select {
    background-color: #fff;
    color: #868686;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Exo-2';
    border: none;
    cursor: pointer;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxNiAxNic+PHBhdGggZmlsbD0nbm9uZScgc3Ryb2tlPScjYjIwMDAwJyBzdHJva2UtbGluZWNhcD0ncm91bmQnIHN0cm9rZS1saW5lam9pbj0ncm91bmQnIHN0cm9rZS13aWR0aD0nMicgZD0nbTIgNSA2IDYgNi02Jy8+PC9zdmc+Cg==);
  }

  .form-select:hover {
    background-color: #6c757d;
    color: #fff;
    border-radius: 30px;
    border: none;
  }

  .img-box {
    position: relative;
    width: 100%;
  }
  video {
    position: relative;
    width: 100%;
    max-height: 480px;
  }

  .img-box img {
    width: 100%;
    height: 450px;
    filter: brightness(0.7);
    background-size: cover;
    object-fit: cover;
    background-position: center;
    object-position: center 25%;
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* Tamanho do ícone de reprodução */
    color: white;
    /* Cor do ícone de reprodução */
    cursor: pointer;
  }

  .mobile-bellacloud > .fa-bookmark,
  .mobile-share > .fa-share-nodes,
  .mobile-download > .fa-download,
  .mobile-sections {
    display: none;
  }

  .model-info span {
    font-family: 'Exo-2';
    font-size: 25px;
    line-height: 20px;
    display: block;
    width: 100%;
    font-family: 'Bebas-Neue';
  }

  @media screen and (max-width: 992px) {
    .model-data,
    .div-resolution,
    .btn-desktop {
      display: none;
    }

    .block {
      padding: 0px;
      margin-top: 0px !important;
    }

    .mobile-bellacloud > .fa-bookmark,
    .mobile-share > .fa-share-nodes,
    .mobile-download > .fa-download,
    .mobile-sections {
      display: block;
    }

    .row >>> #model-video-box {
      margin-bottom: 50px;
    }

    .buttons-video {
      box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
      -webkit-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
      -moz-box-shadow: -2px -3px 26px -12px rgba(0, 0, 0, 0.45);
    }

    .name-video {
      font-family: 'Exo-2';
      font-size: 14px;
      font-weight: bold;
      color: #000000;
    }

    .img-box img {
      width: 992px;
      max-width: 97%;
      height: 300px;
      margin-left: 10px;
      filter: brightness(0.7);
      background-size: cover;
      object-fit: cover;
      background-position: center;
      object-position: center 25%;
    }

    #model-video-box {
      width: 100%;
      height: unset;
      right: unset;
      margin-left: 10px;
    }

    .mobile-sections {
      top: -2px;
    }
  }
</style>
